module.exports = __webpack_public_path__ + "img/circle_normal.23154ef5.svg";